

export const MIN_OPTIONS_COUNT_RADIO = 2;
export const MIN_OPTIONS_COUNT_SELECT = 4;
export const MIN_OPTIONS_COUNT_COMBOBOX = 26;
export const MIN_OPTIONS_COUNT_TOKENFIELD = 4;

export const MAX_OPTIONS_COUNT_RADIO = 3;
export const MAX_OPTIONS_COUNT_SELECT = 25;
